export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
export const getTradeableTokensUrl = (network: string) =>
  `/api/v2/trade/tokens/${network}`;
const ENDPOINTS = {
  USER_WALLETS: `/api/v2/user/wallets`,
  WITHDRAW_FROM_WALLET: `/api/v2/user/wallet/withdraw`,
  YIELD_BEARING_ASSETS: `/api/v2/yield-bearing-assets`,
  YIELD_BEARING_ASSETS_DEPOSIT_ESTIMATE: `/api/v2/yield-bearing-assets/deposit/estimate`,
  YIELD_BEARING_ASSETS_DEPOSIT: `/api/v2/yield-bearing-assets/deposit`,
  YIELD_BEARING_ASSETS_SUBMIT_RATINGS: `/api/v2/yield-bearing-assets/[yield_bearing_asset_ticker]/ratings`,
  YIELD_BEARING_ASSETS_OPTIMIZE_PORTFOLIO: `/api/v2/yield-bearing-assets/optimize-portfolio`,
  USER_MULTI_WALLET_TRANSACTIONS: `/api/v2/user/transactions`,
  USER_WALLET_WITHDRAWAL: '/api/v2/user/wallet/[id]/withdraw',
  NEWS: `/api/v2/news`,
  TRADEABLE_TOKENS_TRADE_ESTIMATE: `/api/v2/trade/estimate`,
  TRADEABLE_TOKENS_TRADE: `/api/v2/trade`,
  RATINGS: `/api/v2/user/ratings`,
  USER_REFERRAL_CREATE: `/api/v2/user/referral`,
  USER_REFERRAL_GET: `/api/v2/user/referral`,
  USER_REFERRAL_APPLY: `/api/v2/user/referral/apply`,
};
export default ENDPOINTS;
